import { TableSortDirection } from '@core/enums/table-sort-direction.enum';

export const TableSortDirectionCycle: { [key: string]: TableSortDirection } = {
  [TableSortDirection.asc]: TableSortDirection.desc,
  [TableSortDirection.desc]: TableSortDirection.none,
  [TableSortDirection.none]: TableSortDirection.asc,
};
